import { render, staticRenderFns } from "./ShippingInsurancesModule.vue?vue&type=template&id=f3b79540"
import script from "./ShippingInsurancesModule.vue?vue&type=script&lang=js"
export * from "./ShippingInsurancesModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports